export default function Footer() {
    return(
        <div className="footer">
            <div className="flex flex__row" style={{width: '100%'}}>
                <div>
                    Copyright © 2023 InterviewAI 
                </div>
                <div className="float--right flex flex__row">
                    <a href="#">Privacy</a>
                    <a href="#">Terms</a>
                </div>
            </div>
        </div>
    )
}